export { SortableModule } from './sortable.module';
export { SortableComponent } from './sortable.component';
export { DraggableItemService } from './draggable-item.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/sortable/index.js
// module id = 400
// module chunks = 3